import React from 'react';
import { theme } from '../../theme';

const variants = {
  primary: {
    background: theme.primary,
    color: theme.white,
    border: `1px solid ${theme.primary}`,
    hoverBg: theme.primaryDark,
  },
  secondary: {
    background: theme.darkSecondary,
    color: theme.white,
    border: `1px solid ${theme.darkSecondary}`,
    hoverBg: theme.dark,
  },
  danger: {
    background: theme.danger,
    color: theme.white,
    border: `1px solid ${theme.danger}`,
    hoverBg: '#DC2626',
  },
  success: {
    background: theme.success,
    color: theme.white,
    border: `1px solid ${theme.success}`,
    hoverBg: '#059669',
  },
  outline: {
    background: 'transparent',
    color: theme.primary,
    border: `1px solid ${theme.primary}`,
    hoverBg: theme.lightBg,
  },
  outlineGray: {
    background: 'transparent',
    color: theme.gray,
    border: `1px solid ${theme.border}`,
    hoverBg: theme.pageBg,
  },
  info: {
    background: theme.info,
    color: theme.white,
    border: `1px solid ${theme.info}`,
    hoverBg: '#2563EB',
  },
  warning: {
    background: theme.warning,
    color: theme.white,
    border: `1px solid ${theme.warning}`,
    hoverBg: '#D97706',
  },
};

const sizes = {
  sm: { padding: '0.35rem 0.75rem', fontSize: '0.8rem' },
  md: { padding: '0.5rem 1.25rem', fontSize: '0.875rem' },
  lg: { padding: '0.75rem 1.75rem', fontSize: '1rem' },
};

function Button({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  onClick,
  type = 'button',
  style = {},
  fullWidth = false,
}) {
  const [hovered, setHovered] = React.useState(false);
  const v = variants[variant] || variants.primary;
  const s = sizes[size] || sizes.md;

  const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    ...s,
    fontWeight: 500,
    borderRadius: '0.5rem',
    border: v.border,
    background: hovered && !disabled ? v.hoverBg : v.background,
    color: v.color,
    cursor: disabled || loading ? 'not-allowed' : 'pointer',
    opacity: disabled || loading ? 0.65 : 1,
    transition: 'all 0.15s ease',
    outline: 'none',
    width: fullWidth ? '100%' : 'auto',
    whiteSpace: 'nowrap',
    ...style,
  };

  return (
    <button
      type={type}
      style={baseStyle}
      disabled={disabled || loading}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {loading && (
        <span
          style={{
            width: '14px',
            height: '14px',
            border: `2px solid ${v.color}40`,
            borderTop: `2px solid ${v.color}`,
            borderRadius: '50%',
            display: 'inline-block',
            animation: 'spin 0.8s linear infinite',
          }}
        />
      )}
      {children}
    </button>
  );
}

export default Button;
